// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--gJmrx","content":"content--TCrel"};